import axios from "axios";

import { client } from "../client";
import { Printer } from "../types/printer.types";

export const createPrinter = async ({
	printer,
}: {
	printer: Partial<Printer>;
}) => {
	const response = await client.post<Printer>(`/printers/`, printer);
	return response.data;
};

export const deletePrinter = async ({
	printer,
}: {
	printer: Partial<Printer>;
}) => {
	if (!printer.id) {
		return null;
	}
	const response = await client.delete(`/printers/${printer.id}/`);
	return response.data;
};

export const print = async ({
	host,
	form,
}: {
	host: string;
	form: FormData;
}) => {
	return axios.post(`${host}/printers/print`, form);
};
